import * as React from 'react';
import { Box, Button, Chip, Divider, Drawer, Typography } from '@mui/material';
import { CloseIcon } from '~/assets/icons';
import styles from './DrawerAccount.module.scss';
import classNames from 'classnames/bind';
import { BaseImage } from '~/components/common';
import { PencilIcon, ArrowRightDoubleIcon } from '~/assets/icons';
import { useTranslation } from 'react-i18next';
import { IAccount } from '~/utils/interface/account';

type DrawerComponentProps = {
  open: boolean;
  data?: IAccount;
  setOpen: (open: boolean) => void;
  setOpenEdit: (open: boolean) => void;
};
const cx = classNames.bind(styles);
const DrawerComponent: React.FC<DrawerComponentProps> = ({ open, setOpen, data, setOpenEdit }) => {
  const { t } = useTranslation(['admin/account']);

  const handleSetOpen = async (open: boolean) => {
    setOpen(open);
  };
  const handleSetEdit = async (open: boolean) => {
    setOpenEdit(open);
  };

  return (
    <Drawer anchor='right' open={open} onClose={() => handleSetOpen(false)} className={cx('drawer')}>
      <Box className={cx('arrowRight')} onClick={() => handleSetOpen(false)}>
        <ArrowRightDoubleIcon className={cx('arrowRightDoubleIcon')} />
      </Box>
      <Box role='presentation' className={cx('drawer-container')}>
        <Box className={cx('avatar-container')}>
          <Box className={cx('image-container')}>
            <BaseImage src={data?.avatar} className={cx('image')} />
            <Box className={cx('name-user')}>
              <Typography variant='h6' gutterBottom className={cx('name')}>
                {data?.name}
              </Typography>
              <Typography variant='body2' className={cx('title')}>
                {data?.roles?.map(({ name }) => (
                  <Chip label={name} size='small' />
                ))}
              </Typography>
            </Box>
          </Box>

          <Box>
            <Box onClick={() => handleSetOpen(false)}>
              <CloseIcon className={cx('iconClose')} />
            </Box>
          </Box>
        </Box>

        <Box className={cx('button-container')}>
          <Button variant='contained' className={cx('edit-info')} onClick={() => handleSetEdit(true)}>
            <PencilIcon className={cx('pen-icon')} />
            {t('editInfo')}
          </Button>
          {/* <Button className={cx('message')} onClick={() => navigate(adminRouteAbsolute.message)}>
            <MessUserIcon className={cx('mess-icon')} />
            {t('message')}
          </Button> */}
        </Box>

        <Box className={cx('infomation-container')}>
          <Box>
            <Typography className={cx('header')}> {t('contactinfomation')}</Typography>
          </Box>
          <Box className={cx('info')}>
            <Typography variant='body2' className={cx('header-title')}>
              {t('phoneNumber')}
            </Typography>
            <Typography variant='body2' className={cx('header-title-item')}>
              {data?.phone}
            </Typography>
          </Box>
          <Box className={cx('info')}>
            <Typography variant='body2' className={cx('header-title')}>
              {t('email')}
            </Typography>
            <Typography variant='body2' className={cx('header-title-item')}>
              {data?.email}
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />
        </Box>

        <Box className={cx('work-container')}>
          <Box>
            <Typography className={cx('header')}>{t('workInfomation')}</Typography>
          </Box>
          <Box className={cx('info')}>
            <Typography variant='body2' className={cx('header-title')}>
              {t('employeeid')}
            </Typography>
            <Typography variant='body2' className={cx('header-title-item')}>
              {data?.id}
            </Typography>
          </Box>
          <Box className={cx('info')}>
            <Typography variant='body2' className={cx('header-title')}>
              {t('department')}
            </Typography>
            <Typography variant='body2' className={cx('header-title-item')}>
              {t(`departmentName.${data?.department}`)}
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />
        </Box>

        <Box className={cx('personal-container')}>
          <Box>
            <Typography className={cx('header')}> {t('personalInfomation')}</Typography>
          </Box>
          <Box className={cx('info')}>
            <Typography variant='body2' className={cx('header-title')}>
              {t('name')}
            </Typography>
            <Typography variant='body2' className={cx('header-title-item')}>
              {data?.name}
            </Typography>
          </Box>
          <Box className={cx('info')}>
            <Typography variant='body2' className={cx('header-title')}>
              {t('address')}
            </Typography>
            <Typography variant='body2' className={cx('header-title-item')}>
              {data?.address}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default React.memo(DrawerComponent);
